
class EventProgramCell extends UITableViewCell
{
    private titleLabel:MUILabel = null;

    awakeFromHTML(){
        this.titleLabel = MUIOutlet(this, "title-lbl", "MUILabel");
    }

    set item(item:EventProgram){
        this.titleLabel.text = item.name;
    }
}